(function(){
  const DRAWER_SEL = '.drawer-content-inner';
  const BTN_SEL = '.quantity-input-button';
  const INPUT_SEL = '.quantity-input-field';
  const REMOVE_SEL = 'cart-remove-button a, .mini-cart-item-remove';

  const inD = el => el && el.closest && el.closest(DRAWER_SEL);
  const drawer = () => document.querySelector(DRAWER_SEL);

  async function refreshDrawerFull(){
    const res = await fetch('/cart?view=mini-cart', { credentials:'same-origin' });
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html,'text/html');
    const fresh = doc.querySelector(DRAWER_SEL) || doc.body;
    const live  = drawer();
    if (fresh && live) {
      // replace just the inner drawer HTML so the drawer stays open
      live.innerHTML = (fresh.classList.contains('drawer-content-inner') ? fresh.innerHTML : fresh.innerHTML);
    }
  }

  async function changeQty(line, quantity){
    await fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ line:Number(line), quantity:Number(quantity) })
    });
    await refreshDrawerFull();
  }

  // CAPTURE: stop defaults AND handle +/- and remove here
  document.addEventListener('click', function(e){
    if (!inD(e.target)) return;

    const btn = e.target.closest(BTN_SEL);
    const remove = e.target.closest(REMOVE_SEL);

    if (btn) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();
      const wrap  = btn.closest('.mini-cart-item, .mini-cart-item-actions, .quantity-input');
      const input = wrap && wrap.querySelector(INPUT_SEL);
      const idx   = Number(input?.dataset.index);
      const cur   = Number(input?.value) || 1;
      const next  = Math.max(0, cur + (btn.name === 'plus' ? 1 : -1));
      if (input) input.value = String(next); // instant visual bump
      if (idx) changeQty(idx, next);
      return;
    }

    if (remove) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.();
      const holder = remove.closest('cart-remove-button');
      const idx = Number(holder?.dataset.index);
      if (idx) changeQty(idx, 0);
      return;
    }

    // Block any other anchor/button clicks inside the drawer from navigating
    const a = e.target.closest('a[href]');
    if (a) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.(); }
  }, true);

  // Typing into the qty box: debounce, then AJAX change
  let t;
  document.addEventListener('input', function(e){
    const input = e.target.closest(INPUT_SEL);
    if (!input || !inD(input)) return;
    e.preventDefault(); e.stopPropagation();
    const idx = Number(input.dataset.index);
    clearTimeout(t);
    t = setTimeout(() => {
      let val = parseInt(input.value,10);
      if (isNaN(val) || val < 1) val = 0; // <=0 removes
      if (idx) changeQty(idx, val);
    }, 150);
  }, true);

  // Never allow form submits from inside the drawer
  document.addEventListener('submit', function(e){
    if (inD(e.target)) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation?.(); }
  }, true);

  console.log('[mini-cart ajax hijack v2] ready');
})();
